import { Box, Center, Container, Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import SEO from 'components/SEO'
import { NextPage } from 'next'
import NextImage from 'next/image'

interface VouchersProps {
  vouchers: Record<string, any>
}

const Vouchers: NextPage<VouchersProps> = ({ vouchers }) => {
  return (
    <Box>
      <SEO
        title="Vouchery"
        description="Szukasz pomysłu na wyjątkowy prezent? Bon Upominkowy to doskonały pomysł na prezent dla ludzi dbających o swoje zdrowie, zabieganych, którzy nie cierpią na nadmiar wolnego czasu, a po ciężkim dniu marzą o chwili relaksu i spokoju."
      />
      <Container maxWidth="container.xl" marginY="3rem">
        <Center flexDirection="column">
          <Box maxWidth="48rem" paddingTop="3rem">
            <Heading size="lg" textAlign={['left', 'left', 'center']}>
              Bony prezentowe
            </Heading>
            <Text fontSize="1.25rem" lineHeight={1.75} marginTop="1rem" textAlign={['left', 'left', 'center']}>
              Bon Upominkowy to doskonały pomysł na prezent dla ludzi dbających o swoje zdrowie, zabieganych, którzy nie
              cierpią na nadmiar wolnego czasu, a po ciężkim dniu marzą o chwili relaksu i spokoju. Naszym klientom
              dajemy możliwość zakupu i zrealizowania fantastycznych bonów upominkowych na pakiety oraz zabiegi
              medyczne.
            </Text>
          </Box>
        </Center>
      </Container>
      <Container maxWidth="container.xl" paddingY={['4rem', '4rem', '8rem']}>
        <SimpleGrid columns={[1, 1, 2]} gap="4rem" alignItems="center">
          <Text fontSize="1.25rem" lineHeight={1.75} maxWidth="32rem" whiteSpace="pre-line">
            {vouchers.attributes.heroContent}
          </Text>
          <Image src={vouchers.attributes.heroImage?.data?.attributes?.url} alt="Prezent" />
        </SimpleGrid>
      </Container>
      <Container maxWidth="container.xl" borderTop="1px solid" paddingY={['4rem', '4rem', '8rem']}>
        <SimpleGrid columns={[1, 1, 2]} gap="4rem" alignItems="center">
          <Image
            src={vouchers.attributes.firstSectionImage?.data?.attributes?.url}
            alt={vouchers.attributes.firstSectionTitle}
          />
          <Stack gap="2rem" alignItems="flex-start">
            <Heading size="lg" fontWeight={500}>
              {vouchers.attributes.firstSectionTitle}
            </Heading>
            <Text fontSize="1.25rem" lineHeight={1.75} maxWidth="32rem" whiteSpace="pre-line">
              {vouchers.attributes.firstSectionContent}
            </Text>
          </Stack>
        </SimpleGrid>
      </Container>
      <Box backgroundColor="gray.200">
        <Container maxWidth="container.xl" paddingY={['4rem', '4rem', '8rem']}>
          <SimpleGrid columns={[1, 1, 2]} gap="4rem" alignItems="center">
            <Stack gap="2rem" alignItems="flex-start">
              <Heading size="lg" fontWeight={500}>
                {vouchers.attributes.secondSectionTitle}
              </Heading>
              <Text fontSize="1.25rem" lineHeight={1.75} maxWidth="32rem" color="gray.700" whiteSpace="pre-line">
                {vouchers.attributes.secondSectionContent}
              </Text>
            </Stack>
            <Image
              src={vouchers.attributes.secondSectionImage?.data?.attributes?.url}
              alt={vouchers.attributes.secondSectionTitle}
            />
          </SimpleGrid>
        </Container>
      </Box>
      <Container maxWidth="container.xl" paddingY={['4rem', '4rem', '8rem']}>
        <SimpleGrid columns={[1, 1, 2]} gap="4rem" alignItems="center">
          <Image
            src={vouchers.attributes.thirdSectionImage?.data?.attributes?.url}
            alt={vouchers.attributes.thirdSectionTitle}
          />
          <Stack gap="2rem" alignItems="flex-start">
            <Heading size="lg" fontWeight={500}>
              {vouchers.attributes.thirdSectionTitle}
            </Heading>
            <Text fontSize="1.25rem" lineHeight={1.75} maxWidth="32rem" whiteSpace="pre-line">
              {vouchers.attributes.thirdSectionContent}
            </Text>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  )
}

export async function getServerSideProps() {
  const VOUCHERS_DATA_URL = `${process.env.NEXT_PUBLIC_API_URL}/api/voucher?populate=firstSectionImage,secondSectionImage,thirdSectionImage,heroImage`
  const res = await fetch(VOUCHERS_DATA_URL)
  const { data } = await res.json()
  return { props: { vouchers: data } }
}

export default Vouchers
